import { PieChart, Pie, Cell, Tooltip } from "recharts";

const COLORS = ["#8884d8", "#e0e0e0"]; 

const HalfDonutTarget = ({ month = [] }) => {
  const currentMonthKey = new Date().toISOString().slice(0, 7); 

  // Extract current month revenue
  const currentMonthData = month.find((m) => m.month === currentMonthKey);
  const revenueValue = Number(currentMonthData?.revenue || currentMonthData?.total_amount || 0);

  // Find highest revenue (target)
  const targetValue = Math.max(
    ...month.map((m) => Number(m.revenue || m.total_amount || 0))
  );

  const percentage =
    targetValue > 0 ? Math.round((revenueValue / targetValue) * 100) : 0;

  const data = [
    { name: "Progress", value: percentage > 100 ? 100 : percentage },
    { name: "Remaining", value: percentage > 100 ? 0 : 100 - percentage },
  ];

  const captions = [
    "🚀 Great progress! Keep up the momentum!",
    "🔥 You're on fire! Let's keep going!",
    "💪 Strong efforts bring big rewards!",
    "🎯 Stay focused — you're doing amazing!",
    "🌟 Vendors like you inspire success!",
    "📈 Keep climbing — the top is near!",
    "👏 Outstanding work — consistency is key!",
    "🏆 You're on the path to greatness!",
    "💼 Keep pushing — every bit counts!",
    "💪 Boost up! You're doing fantastic!",
  ];

  return (
    <div
      className="donut-container"
      style={{ position: "relative", width: 260 }}
    >
      <PieChart width={260} height={100}>
        <Tooltip
          contentStyle={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "8px",
            fontSize: "0.85rem",
          }}
          formatter={(value, name) => [`${value}%`, name]}
        />
        <Pie
          data={data}
          cx="50%"
          cy="100%"
          startAngle={190}
          endAngle={0}
          innerRadius={60}
          outerRadius={90}
          paddingAngle={3}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`slice-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>

      <div
        style={{
          position: "absolute",
          top: 60,
          left: "50%",
          transform: "translateX(-50%)",
          textAlign: "center",
          fontWeight: "bold",
          color: "#4e54c8",
        }}
      >
        <div style={{ fontSize: "16px" }}>{percentage}%</div>
        <div style={{ fontSize: "13px" }}>
          {percentage >= 100 ? "Target Achieved!" : "You can achieve it!"}
        </div>
      </div>

      <div className="donut-caption" style={{ marginTop: 10 }}>
        {captions[Math.floor(Math.random() * captions.length)]}
      </div>

      <div className="donut-labels" style={{ marginTop: 8 }}>
        <div className="info-box">
          <span className="label">Target</span>
          <span className="value">₹ {targetValue.toLocaleString()}</span>
        </div>
        <div className="info-box">
          <span className="label">Revenue</span>
          <span className="value">₹ {revenueValue.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default HalfDonutTarget;
